/**
 * User: WangMeng
 * Date: 2018-07-17
 * Time: 17:45
 * Desc: 一股独大
 */

import { formatNumber } from '../../../../../utils/formatter';
import BaseDangerDetail from '../../../common/baseDangerDetail/BaseDangerDetail';

export default class SingleLargeShareholder extends BaseDangerDetail {
    constructor(props) {
        super(props);
        this.title = '前十大股东持股信息';
    }

    getColumns = () => {
        return [{
            title: '序号',
            dataIndex: 'rowNum',
            width: 60
        }, {
            title: '股东名称',
            dataIndex: 'name'
        }, {
            title: '持股数量',
            dataIndex: 'number',
            width: 150,
            render: formatNumber
        }, {
            title: '持股比例',
            dataIndex: 'ratio',
            width: 150
        }];
    };
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialRiskAnalysis/subComponents/danger/SingleLargeShareholder.jsx